import React from 'react';

// 사업자정보 푸터 — 결제경로(로그인/가입/결제) 화면 하단에 노출.
// 토스 빌링 심사 [2]-2 하단정보 6종 + 전자상거래법 사이버몰 표시 의무.
// 약관·개인정보처리방침 문서는 랜딩(washnote.kr)에 단일 관리, 여기선 링크만.
const BIZ = {
    company: '얼라인싱크 (AlignSync)',
    ceo: '이상훈',
    bizNo: '193-09-03559',
    saleNo: '2026-창원성산-0332',
    address: '경상남도 창원시 성산구 비음로 4번길 37-20 (사파동)',
    tel: '0507-1352-7364',
    email: 'dltkdgns0303@gmail.com',
};

const SiteFooter = () => (
    <footer className="site-footer">
        <div className="site-footer-links">
            <a href="https://washnote.kr/terms.html" target="_blank" rel="noopener noreferrer">이용약관</a>
            <span className="site-footer-sep">·</span>
            <a href="https://washnote.kr/privacy.html" target="_blank" rel="noopener noreferrer">개인정보처리방침</a>
        </div>
        <div className="site-footer-biz">
            상호: {BIZ.company} | 대표: {BIZ.ceo} | 사업자등록번호: {BIZ.bizNo}
            {BIZ.saleNo && <> | 통신판매업신고번호: {BIZ.saleNo}</>}
            <br />
            사업장 주소: {BIZ.address}
            <br />
            고객센터: <a href={`tel:${BIZ.tel}`}>{BIZ.tel}</a> | 이메일: <a href={`mailto:${BIZ.email}`}>{BIZ.email}</a>
        </div>
        <div className="site-footer-copy">&copy; {new Date().getFullYear()} AlignSync. All rights reserved.</div>
    </footer>
);

export default SiteFooter;
